var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95801 1.86426C2.35395 1.86426 1.86426 2.35395 1.86426 2.95801V7.95801C1.86426 8.56207 2.35395 9.05176 2.95801 9.05176H7.95801C8.56207 9.05176 9.05176 8.56207 9.05176 7.95801V2.95801C9.05176 2.35395 8.56207 1.86426 7.95801 1.86426H2.95801ZM3.42676 7.48926V3.42676H7.48926V7.48926H3.42676Z",
    fill: "#070A26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3955 1.86426C10.7914 1.86426 10.3018 2.35395 10.3018 2.95801V7.95801C10.3018 8.56207 10.7914 9.05176 11.3955 9.05176H16.3955C16.9996 9.05176 17.4893 8.56207 17.4893 7.95801V2.95801C17.4893 2.35395 16.9996 1.86426 16.3955 1.86426H11.3955ZM11.8643 7.48926V3.42676H15.9268V7.48926H11.8643Z",
    fill: "#070A26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86426 11.3955C1.86426 10.7914 2.35395 10.3018 2.95801 10.3018H7.95801C8.56207 10.3018 9.05176 10.7914 9.05176 11.3955V16.3955C9.05176 16.9996 8.56207 17.4893 7.95801 17.4893H2.95801C2.35395 17.4893 1.86426 16.9996 1.86426 16.3955V11.3955ZM3.42676 11.8643V15.9268H7.48926V11.8643H3.42676Z",
    fill: "#070A26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3318 10.2492C14.5386 9.45594 13.2524 9.45594 12.4592 10.2492L10.2495 12.4589C9.45624 13.2522 9.45624 14.5383 10.2495 15.3315L12.4592 17.5412C13.2524 18.3345 14.5386 18.3345 15.3318 17.5412L17.5415 15.3315C18.3348 14.5383 18.3348 13.2522 17.5415 12.4589L15.3318 10.2492ZM13.5641 11.354C13.7471 11.171 14.0439 11.171 14.227 11.354L16.4367 13.5638C16.6197 13.7468 16.6197 14.0436 16.4367 14.2267L14.227 16.4364C14.0439 16.6194 13.7471 16.6194 13.5641 16.4364L11.3543 14.2267C11.1713 14.0436 11.1713 13.7468 11.3543 13.5638L13.5641 11.354Z",
    fill: "#070A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.a9c5b72053894cfc874a7f1acb8b2606.svg";
export { ForwardRef as ReactComponent };